import { createRoute } from '@tanstack/react-router'
import { Route as rootRoute } from '@/app/__root'
import { ROUTES } from '@/shared/constants/routes'
import { OnboardingPetPage } from './page.onboarding.pet'

export const Route = createRoute({
    getParentRoute: () => rootRoute,
    path: ROUTES.ONBOARDING_PET,
    component: OnboardingPetPage,
})
